import { createReducer } from '@reduxjs/toolkit'
import { IStateAccessRules } from './TReducer'
import { Actions_AccessRules } from './Actions'

const initialState: IStateAccessRules = {
  isLoading: false,
  data: null,
  responseInfo: null,
}

const ReducerAccessRules = createReducer(initialState, (builder) => {
  builder
    .addCase(Actions_AccessRules.store.showLoader, (state) => {
      state.isLoading = true
    })
    .addCase(Actions_AccessRules.store.hideLoader, (state) => {
      state.isLoading = false
    })
    .addCase(Actions_AccessRules.store.saveAccessRules, (state, action) => {
      const payload = action.payload
      return { ...state, ...payload }
    })
})

export default ReducerAccessRules
